import React from "react";
import { LanguageCode, pickLang } from "../../utils/translations";
import { COLORS } from "../../utils/constants";

interface CTASectionProps {
  lang: LanguageCode;
}

const CTASection: React.FC<CTASectionProps> = ({ lang }) => {
  const content = {
    en: {
      title: "Want to Apply These Insights?",
      desc: "Use our tools to discover trending tags, analyze videos, and plan smarter YouTube content.",
      button: "Find Trending Tags",
    },
    hi: {
      title: "इन जानकारियों का उपयोग करना चाहते हैं?",
      desc: "ट्रेंडिंग टैग खोजने, वीडियो मेटाडेटा का विश्लेषण करने और स्मार्ट YouTube कंटेंट प्लान करने के लिए हमारे टूल्स का उपयोग करें।",
      button: "ट्रेंडिंग टैग्स खोजें",
    },
    fr: {
      title: "Envie d'appliquer ces idées ?",
      desc: "Utilisez nos outils pour découvrir les tags tendance, analyser les vidéos et planifier un contenu YouTube plus intelligent.",
      button: "Trouver les tags tendance",
    },
  };

  const { title, desc, button } = pickLang(content, lang);

  return (
    <section
      style={{
        padding: "40px 8%",
        backgroundColor: COLORS.brandPurple, // Updated to use COLORS
        color: "white",
        textAlign: "center",
        marginTop: "-1px",
      }}
    >
      <h2
        style={{
          fontSize: "2.1rem",
          marginBottom: "0.8rem",
          fontWeight: 800,
          marginTop: 0,
        }}
      >
        {title}
      </h2>

      <p
        style={{
          maxWidth: "600px",
          margin: "0 auto 1.5rem",
          fontSize: "1rem",
          opacity: 0.9,
          lineHeight: "1.5",
          marginTop: 0,
        }}
      >
        {desc}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <button
          style={{
            backgroundColor: COLORS.brandTeal, // Updated to use COLORS
            color: "white",
            padding: "12px 24px",
            borderRadius: "6px",
            border: "none",
            fontWeight: 700,
            cursor: "pointer",
            fontSize: "0.95rem",
            transition: "transform 0.2s ease, background-color 0.2s ease",
          }}
          onClick={() => (window.location.href = "/#tag-extractor")}
          onMouseOver={
            (e) => (e.currentTarget.style.filter = "brightness(90%)") // Dynamic hover effect
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.filter = "brightness(100%)")
          }
        >
          {button}
        </button>
      </div>
    </section>
  );
};

export default CTASection;
